import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Obstacle = {
  id: PropTypes.number,
  type: PropTypes.string,
  marking: PropTypes.string,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const ObstacleShape = PropTypes.shape(Obstacle);
export const ObstacleExact = PropTypes.exact(Obstacle);
